import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

import {
  getTvCode,
  getCurrentProfile,
} from '#/redux/modules/onboarding/selectors';
import { isUserLogged } from '#/redux/modules/user/selectors';

import routes from '#/utils/routes';

// Component to guide user to activate page, if code exists, or select a profile
const LoginRedirect = () => {
  const savedTvCode = useSelector(getTvCode);
  const currentProfile = useSelector(getCurrentProfile);
  const isUserLoggedIn = useSelector(isUserLogged);

  const redirect = useMemo(() => {
    if (!isUserLoggedIn) {
      return null;
    }

    const profilesRedirect = currentProfile ? (
      <Redirect to={routes.HOME} />
    ) : (
      <Redirect to={routes.PROFILE_SELECTION} />
    );
    return savedTvCode ? (
      <Redirect to={routes.ACTIVATE_COMPLETE} />
    ) : (
      profilesRedirect
    );
  }, [isUserLoggedIn, savedTvCode, currentProfile]);

  return <>{redirect}</>;
};

export default LoginRedirect;
